import { videoSnaphotToBlob } from "../../../utils/faceapi_utils";
import { updateSnapshotCount, addSnapshotLog } from "./snapshotSlice";
import { updateMultiFaceNo } from "../warning/warningSlice";
import logTypes from "../logTypes";
import { v4 as uuidv4 } from "uuid";
import { submitFlags } from "../../activityAsyncAction";

export function takeSnapshotAsync(videoEl, displaySize, logType) {
  return async (dispatch, getState) => {
    videoEl.pause();
    const {
      timer: {
        times: { startTime },
      },
    } = getState();

    if (logType === logTypes.PERIODIC_SNAPSHOT) {
    } else if (logType === logTypes.FACE_ABSENCE) {
    } else if (logType === logTypes.MULTIPLE_FACE) {
      dispatch(updateMultiFaceNo());
    }
    dispatch(updateSnapshotCount());
    let snapshotLog = {
      id: uuidv4(),
      logType,
      saved: false,
      time: Date.now(),
    };
    const imageBlob = await videoSnaphotToBlob(videoEl, displaySize);
    console.log("this is the image snapshot", imageBlob);
    videoEl.play();
    snapshotLog.dataUrl = window.URL.createObjectURL(imageBlob);
    dispatch(addSnapshotLog(snapshotLog));
    dispatch(submitFlags({ ...snapshotLog, dataBlob: imageBlob }));
    //send blob logic has to be here
  };
}
